import { useGLTF, useAnimations } from '@react-three/drei';
import { useLoader, useFrame } from '@react-three/fiber';
import { useRef } from 'react';
import { ObjectLoader, TextureLoader, Color } from 'three';
import { d as defineSrc } from './index-CAxCDj_E.esm.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import 'clsx';
import './common-DBpCdW70.esm.js';

const MultiCurrency = () => {
  const ref = useRef();
  const model = useGLTF(defineSrc('multi-currency.glb'));
  const lights = useLoader(ObjectLoader, defineSrc('multi-currency-light.json'));
  const wiseLogo = useLoader(TextureLoader, defineSrc('wise-flag-map-bump.jpg'));
  const animatedMaps = [];
  model.scene.traverse(child => {
    if (child.name.includes('Note')) {
      child.castShadow = true;
      child.receiveShadow = true;
    }
    if (child.name.startsWith('Coin_') && child.isMesh) {
      const {
        material
      } = child;
      material.bumpMap = wiseLogo;
      material.bumpMap.flipY = false;
      material.bumpScale = 1;
      material.color = new Color(0.49, 0.49, 0.49);
      child.castShadow = false;
      child.receiveShadow = false;
    }
    if (child.name.startsWith('NoteBase_') && child.isMesh) {
      animatedMaps.push(child.material.map);
    }
    if (child.name.includes('Wise') && child.isMesh) {
      animatedMaps.push(child.material.map);
    }
  });
  const {
    mixer,
    clips
  } = useAnimations(model.animations, ref);
  useFrame(() => {
    animatedMaps.forEach(animatedMap => {
      animatedMap.offset.x += 0.001;
    });
    mixer.clipAction(clips[0]).play();
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("primitive", {
      ref: ref,
      position: [-0.5, -10, 0],
      scale: 1.3,
      object: model.scene
    }), /*#__PURE__*/jsx("primitive", {
      object: lights
    })]
  });
};

export { MultiCurrency as default };
//# sourceMappingURL=MultiCurrency-Dug8SyTe.esm.js.map
